import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ArticoliService} from '../../../_services/articoli.service';
import {Giacenza} from '../../../_models/Giacenza';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {SaveMessage} from '../../../_helpers/save-message';
import {Contenitore} from '../../../_models/Contenitore';

@Component({
    selector: 'app-articolo-giacenza',
    templateUrl: './articolo-giacenza.component.html',
    styleUrls: ['./articolo-giacenza.component.scss'],
    standalone: false
})
export class ArticoloGiacenzaComponent  implements OnInit {
  @Input() activeSelect = false;
  @Input() codArt = '';
  @Output() contenitoreSelect = new EventEmitter<Contenitore>();
  @Input() codMag = '';
  @Input() codMagArea = '';
  @Input() activeEdit = false;
  giacenze: Giacenza[] = [];
  grouped: Array<any> = [];
  loading = false;
  constructor(
    private organizzazioneService: OrganizzazioniService,
    private articoliService: ArticoliService,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    this.getGiacenza();
  }

  onSelectContenitore = (contenitore: Contenitore) => this.contenitoreSelect.emit(contenitore);

  getGiacenza() {
    this.loading = true;
    this.articoliService.getGiacenza(this.organizzazioneService.organizzazioneId, this.codArt,
      this.codMag, this.codMagArea, '',-1)
      .then((_giacenze: SearchResult<Giacenza>) => {
        this.giacenze = _giacenze.result ?? [];
        this.groupByMagAndArea();
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento delle giacenze."))
      .finally(() => this.loading = false);
  }

  private groupByMagAndArea() {
    const map = new Map<string, Map<string, any[]>>();

    (this.giacenze || []).forEach(item => {
      const mag = item.codMag || '—';
      const area = item.codAreaMag || '—';

      if (!map.has(mag)) {
        map.set(mag, new Map());
      }
      const areaMap = map.get(mag)!;

      if (!areaMap.has(area)) {
        areaMap.set(area, []);
      }
      areaMap.get(area)!.push(item);
    });

    this.grouped = Array.from(map.entries()).map(([mag, areaMap]) => {
      const areas = Array.from(areaMap.entries()).map(([area, items]) => ({
        area, items,
        total: items.reduce((s, it) => s + (Number(it.giacenza) || 0), 0),
      }));

      return { mag, areas,
        total: areas.reduce((s, a) => s + a.total, 0),
      };
    });
  }
}
